<template>
  <BaseCard v-if="loading">
    <BaseCardBody>
      <div class="text-center">
        <Loader />
      </div>
    </BaseCardBody>
  </BaseCard>
  <div v-else-if="resolved" class="flex flex-col lg:h-0 lg:min-h-full">
    <BaseCard class="h-full flex flex-col">
      <Conversation v-if="conversation" :conversation="conversation" />
      <BaseCardBody v-else class="flex-1 bg-gray-100">
        <StartConversation :contact-request="contactRequest" @created="fetchConversation" />
      </BaseCardBody>
    </BaseCard>
  </div>
  <div v-else>Something went wrong.</div>
</template>

<script>
import Conversation from './conversationManager/Conversation.vue';
import StartConversation from './conversationManager/StartConversation.vue';

export default {
  components: { Conversation, StartConversation },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    conversation() {
      return this.$store.getters['ui/contactRequestConversation/itemByParent'](
        this.contactRequest.id
      );
    },
  },
  created() {
    this.init();
  },
  destroyed() {
    this.$store.commit('ui/contactRequestConversation/setIdByParent', {
      parentId: this.contactRequest.id,
      id: null,
    });
  },
  methods: {
    setLoading(loading = true) {
      this.loading = Boolean(loading);
    },
    setResolved(resolved = true) {
      this.resolved = Boolean(resolved);
    },
    setRejected(rejected = true) {
      this.rejected = Boolean(rejected);
    },
    async init() {
      try {
        this.setLoading();

        await this.fetchConversation();

        this.setResolved();
      } catch (error) {
        this.setRejected();
      } finally {
        this.setLoading(false);
      }
    },
    fetchConversation() {
      return this.$store.dispatch('ui/contactRequestConversation/read', {
        id: this.contactRequest.id,
        query: {
          include: 'participants.participable',
        },
      });
    },
  },
};
</script>
